import React from "react";
import { type UserStatsCardsProps } from "utils/types/usersManagement.type";

export default function UserStatsCards({
  stats,
  isLoading,
}: UserStatsCardsProps) {
  if (isLoading || !stats) {
    return null;
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
      <div className="bg-cyan-300 rounded-lg p-4">
        <p className="text-black-800 text-xs mb-1">Total Users</p>
        <p className="text-black-900 text-2xl font-bold">{stats.total}</p>
      </div>
      <div className="bg-green-100 rounded-lg p-4">
        <p className="text-black-800 text-xs mb-1">Active</p>
        <p className="text-black-900 text-2xl font-bold">{stats.active}</p>
      </div>
      <div className="bg-red-100 rounded-lg p-4">
        <p className="text-black-800 text-xs mb-1">Inactive</p>
        <p className="text-black-900 text-2xl font-bold">{stats.inactive}</p>
      </div>
      <div className="bg-blue-100 rounded-lg p-4">
        <p className="text-black-800 text-xs mb-1">Verified</p>
        <p className="text-black-900 text-2xl font-bold">{stats.verified}</p>
      </div>
      <div className="bg-yellow-100 rounded-lg p-4">
        <p className="text-black-800 text-xs mb-1">Unverified</p>
        <p className="text-black-900 text-2xl font-bold">{stats.unverified}</p>
      </div>
    </div>
  );
}

